import gql from 'graphql-tag'
import fragment from './fragment'

export default gql`
	mutation CA_updateCashBook($id: ID!, $fields: CashBookUpdateFields) {
		cashAssist {
			updateCashBook(id: $id, fields: $fields) {
				...CashBookFragment
			}
		}
	}
${fragment}`
